export default __webpack_public_path__ + "static/media/15.56f5ead6.png";